import { DestinationData } from '@/scopes/destinations/domain/types/destinationDataClient'
import { DestinationApiRawResponse, DestinationGroup, destinationGroup } from '@/scopes/destinations/infrastructure/types'

export interface DestinationResponseMapper {
  map: (response: DestinationApiRawResponse) => DestinationData
}

export function createDestionationResponseMapper(): DestinationResponseMapper {
  function map(response: DestinationApiRawResponse): DestinationData {
    const findGroup = (group: DestinationGroup) =>
      response.groupItems.find(g => g.group === group)?.options ?? []

    const mapOptions = (items: ReturnType<typeof findGroup>) =>
      items.map(({ name, url, isSelected }) => ({ name, url, isSelected }))

    return {
      country: mapOptions(findGroup(destinationGroup.Country)),
      region: mapOptions(findGroup(destinationGroup.Region)),
      subregion: mapOptions(findGroup(destinationGroup.Subregion)),
      city: mapOptions(findGroup(destinationGroup.City)),
    }
  }

  return {
    map,
  }
}
